import CustomToastContent from './CustomToastContent';

export default CustomToastContent;
